<template>
  <article class="modal_password">
    <section class="modal_password__modal">
      <div class="modal_password__modal__info">
        <h5>Activar cambio de contraseña</h5>
        <p>Una vez haga clic en “Activar” se activará la cédula del usuario como su contraseña por 60 segundos. Esto le permitirá al usuario realizar el cambio de contraseña.</p>
      </div>
      <div class="modal_password__modal__buttons">
        <button @click="onActivateModal" class="modal_password__modal__buttons--left">
          ACTIVAR
        </button>
        <button @click="onCancelModal" class="modal_password__modal__buttons--right">
          CANCELAR
        </button>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  methods:{
    onCancelModal(event){
      this.$emit('cancel', false);
    },
    onActivateModal(event){
      this.$emit('activate', true);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/ModalPassword.vue